import { Outlet, createRootRouteWithContext, ScrollRestoration } from "@tanstack/react-router";
import * as React from "react";
import { type AuthState } from "@/auth/AuthProvider";
import { RouterDevtools } from "@/components/TanStackRouterDevtools";
import { Toaster } from "@/components/ui/sonner";

interface RouterContext {
  auth: AuthState | undefined;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <React.Fragment>
      <Outlet />
      <RouterDevtools />
      <ScrollRestoration />
      <Toaster />
    </React.Fragment>
  );
}
